import React from 'react';
import Header from '#/components/Form/Header/Header';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TRootState } from '#/redux/store';
import PreviewLayout from '#/components/Layout/PreviewLayout/PreviewLayout';
import ArtistPreview from '#/components/Layout/ArtistPreview/ArtistPreview';
import { ROUTE_NAMES } from '#/router/routes';

const Following = () => {
  const librarySlice = useSelector((state: TRootState) => state.library);

  const { artists } = librarySlice;

  const navigate = useNavigate();

  return (
    <div className="p-theme-page-padding">
      <Header
        className=" text-2xl font-bold tracking-tighter mt-4 mb-5"
        type="h1"
      >
        Following
      </Header>
      <PreviewLayout>
        {Array.isArray(artists) &&
          artists.map((artist) => {
            const { id, name, images, uri } = artist;
            const handleOnClick = () => navigate(`${ROUTE_NAMES.ARTIST}/${id}`);
            return (
              <ArtistPreview
                uri={uri}
                key={id}
                onClick={handleOnClick}
                name={name}
                image={images[0].url}
              />
            );
          })}
      </PreviewLayout>
    </div>
  );
};

export default Following;
